import styled, {css} from "styled-components"
import SearchBox from "./search-box"
import {spacing} from "../../styles/Rythms"

export default styled(SearchBox)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 0;

  .SearchInput {
    outline: none;
    border: 1px solid var(--neutral20);
    box-shadow: inset;
    font-size: var(--font-sm);
    border-radius: 8px;
    color: var(--text);

    ::placeholder {
      color: var(--neutral30);
    }

    width: 12em;
    background: var(--white);
    cursor: text;
    margin-left: -1.8em;
    padding: .4rem .4rem .4rem 1.8em;
  }

  .SearchIcon {
    width: .65em;
    margin: 0.3em;
    color: var(--neutral30);
    pointer-events: none;
  }
`
